export default __webpack_public_path__ + "static/media/grafema_minha-casa_05.8ad9a2fd.jpg";